// extracted by mini-css-extract-plugin
export var backgroundImage = "extensionHero-module--backgroundImage--BcbfT";
export var body = "extensionHero-module--body--zzA6L";
export var breadcrumbs = "extensionHero-module--breadcrumbs--tFdTk";
export var companyBackground = "extensionHero-module--companyBackground---FxpN";
export var companyImage = "extensionHero-module--companyImage--fr+nf";
export var companyWrapper = "extensionHero-module--companyWrapper--5RUzL";
export var header = "extensionHero-module--header--WpflI";
export var heroWithBackround = "extensionHero-module--heroWithBackround--qKtlL";
export var sbShowMain = "extensionHero-module--sb-show-main--QpjJt";
export var storybook = "extensionHero-module--storybook--091XP";